import { render, staticRenderFns } from "./menu-tree-select.vue?vue&type=template&id=caa36472"
import script from "./menu-tree-select.vue?vue&type=script&lang=js"
export * from "./menu-tree-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports